import { createSlice } from "@reduxjs/toolkit";
import { fetchApprovedPurchaseRequest } from "./thunk";

interface aprovedPRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  // selectedRFQ: any; 
}

const initialState: aprovedPRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
  // selectedRFQ: null,
};

const aprovedPRSlice = createSlice({
  name: "aprovedPR",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchApprovedPurchaseRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApprovedPurchaseRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchApprovedPurchaseRequest.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch Purchase Order Log";
      });
  },
});

export default aprovedPRSlice.reducer;
